import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { SignUpPayload } from '../hooks/useSignUpState';

export const useSsoSignUpQuery = (employeeId: string) => {
  const { mutateAsync: singUpSso } = useMutation((payload: SignUpPayload) =>
    api.put<{ id: string }>(API_URL.EMPLOYEES_SSO_SIGNUP_BY_EMPLOYEE_ID(employeeId), {
      new_user_name: payload.username,
      new_password: payload.password,
      confirm_password: payload.confirmPassword,
      personal_email: payload.email,
      is_electronic_statement_only: payload.isElectronicStatementOnly,
    })
  );

  return { singUpSso };
};
